// import CryptoJS from 'crypto-js'
const customTypeMap = {
  'm3u8': 'hls',
  'flv': 'flv'
}
const ryan = {
    // encrypt(str) {
    //     let ciphertext = CryptoJS.AES.encrypt(str, "wcM7CNEd6BwBEc87");
    //     return ciphertext;
    // },
    // decrypt(str, isJson = true) {
    //     let bytes = CryptoJS.AES.decrypt(str, 'wcM7CNEd6BwBEc87');
    //     let plaintext = bytes.toString(CryptoJS.enc.Utf8);
    //     return isJson ? JSON.parse(plaintext) : plaintext;
    // },
    getRandom(start, end, fixed = 0) {
        let differ = end - start
        let random = Math.random()
        return (start + differ * random).toFixed(fixed)
    },
    formatTime(number, format) {
        var formateArr = ['Y', 'm', 'd', 'h', 'm', 's'];
        var returnArr = [];

        var date = new Date(number * 1000);
        returnArr.push(date.getFullYear());
        returnArr.push(this.formatNumber(date.getMonth() + 1));
        returnArr.push(this.formatNumber(date.getDate()));

        returnArr.push(this.formatNumber(date.getHours()));
        returnArr.push(this.formatNumber(date.getMinutes()));
        returnArr.push(this.formatNumber(date.getSeconds()));

        for (var i in returnArr) {
            format = format.replace(formateArr[i], returnArr[i]);
        }
        return format;
    },
    timeago(dateTimeStamp) {
        var minute = 1000 * 60;      //把分，时，天，周，半个月，一个月用毫秒表示
        var hour = minute * 60;
        var day = hour * 24;
        var week = day * 7;
        // var halfamonth = day * 15;
        var month = day * 30;
        var now = new Date().getTime();   //获取当前时间毫秒
        var diffValue = now - dateTimeStamp;//时间差
        var result = '';

        if (diffValue < 0) {
            return;
        }
        var minC = diffValue / minute;  //计算时间差的分，时，天，周，月
        var hourC = diffValue / hour;
        var dayC = diffValue / day;
        var weekC = diffValue / week;
        var monthC = diffValue / month;
        if (monthC >= 1 && monthC <= 3) {
            result = " " + parseInt(monthC) + "月前"
        } else if (weekC >= 1 && weekC <= 3) {
            result = " " + parseInt(weekC) + "周前"
        } else if (dayC >= 1 && dayC <= 6) {
            result = " " + parseInt(dayC) + "天前"
        } else if (hourC >= 1 && hourC <= 23) {
            result = " " + parseInt(hourC) + "小时前"
        } else if (minC >= 1 && minC <= 59) {
            result = " " + parseInt(minC) + "分钟前"
        } else if (diffValue >= 0 && diffValue <= minute) {
            result = "刚刚"
        } else {
            var datetime = new Date();
            datetime.setTime(dateTimeStamp);
            var Nyear = datetime.getFullYear();
            var Nmonth = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
            var Ndate = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
            var Nhour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
            var Nminute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
            var Nsecond = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
            result = Nyear + "-" + Nmonth + "-" + Ndate
        }
        return result;
    },
    formatNumber(n) {
        n = n.toString()
        return n[1] ? n : '0' + n
    },
    getRandomArrayElements(arr, count) {
        let shuffled = arr.slice(0), i = arr.length, min = i - count, temp, index;
        while (i-- > min) {
            index = Math.floor((i + 1) * Math.random());
            temp = shuffled[index];
            shuffled[index] = shuffled[i];
            shuffled[i] = temp;
        }
        return shuffled.slice(min);
    },
    getSuffix(str) {
        let value = ''
        if (typeof (str) !== 'string') return;
        let type = {rtmp: 'rtmp/flv', flv: 'video/x-flv', hls: 'application/x-mpegURL', m3u8: 'application/x-mpegURL', ts: ''};
        if (str.substr(0, 4) === 'rtmp') value = {type: type['rtmp'], suffix: 'rtmp'};
        let suffix = str.substring(str.lastIndexOf('.') + 1, str.length);
        switch (suffix) {
            case 'flv':
            case 'm3u8':
                value = {type: type[suffix], suffix: suffix};
                break;
        }
        if (str.indexOf('flv') > -1) value = {type: type['flv'], suffix: 'flv'};
        if (str.indexOf('hls') > -1) value = {type: type['hls'], suffix: 'hls'};
        if (str.indexOf('m3u8') > -1) value = {type: type['m3u8'], suffix: 'm3u8'};
        if (value) {
          value.suffix = customTypeMap[value.suffix] || value.suffix
          return value
        }
        return {type: ''}
    }
}

export default ryan;


// WEBPACK FOOTER //
// ./src/ryan/index.js